import { render, staticRenderFns } from "./IdentificationDocumentForm.vue?vue&type=template&id=2b6eb052&scoped=true&"
import script from "./IdentificationDocumentForm.vue?vue&type=script&lang=ts&"
export * from "./IdentificationDocumentForm.vue?vue&type=script&lang=ts&"
import style0 from "./IdentificationDocumentForm.vue?vue&type=style&index=0&id=2b6eb052&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b6eb052",
  null
  
)

export default component.exports